import { GetLockstatusData } from "./../actions/device-mgmt";
import { call, put } from "redux-saga/effects";
import { getToken } from "../authentication";
import axios from "axios";
import {
  IGetAllAlertCountData,
  IGetAllBatteryTemperatureCount,
  IGetAllCardCountData,
  IGetAllChargeBandStatusCount,
  IGetAllFleetUptimeData,
  IGetAllLiveSpeedBandCountData,
  IGetAllSubscriptionData,
  IGetAllTripData,
  IGetAllVehicleData,
  IGetAllVehicleGraphDetailsData,
  IGetAllVehicleRunningData,
} from "../actions/dashboard-2.0";

export function* getAllChargeBandStatusCount(
  params: IGetAllChargeBandStatusCount
) {
  try {
    let { data } = yield call(getAllChargeBandStatusCountApi, params);
    yield put({
      type: "STORE_ALL_CHARGE_BAND_STATUS_COUNT",
      payload: data,
    });
  } catch (error) {
    console.error("getAllFirmWare", error);
  }
}

export async function getAllChargeBandStatusCountApi(
  params: IGetAllChargeBandStatusCount
) {
  const OEMURL = `${process.env.REACT_APP_WEBAPPAPI}/dashBoardV2/idleChargeBandCount?orgId=${params.payload.orgId}&customerId=${sessionStorage.getItem("selectedFilterCustomerId")}&groupId=${sessionStorage.getItem("groupDetails")}`
  const OPURL = `${process.env.REACT_APP_WEBAPPAPI}/dashBoardV2/chargeBandCount?orgId=${params.payload.orgId}&customerId=${sessionStorage.getItem("selectedFilterCustomerId")}&groupId=${sessionStorage.getItem("groupDetails")}`

  const tokenRes = await getToken();
  const res = await axios.get(params.payload.flag ? OEMURL : OPURL,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: tokenRes.token!,
      },
    }
  );
  return res.data;
}

export function* getAllBatteryTemperatureCount(
  params: IGetAllBatteryTemperatureCount
) {
  try {
    let { data } = yield call(getAllBatteryTemperatureCountApi, params);
    yield put({
      type: "STORE_ALL_BATTERY_TEMPERATURE_COUNT",
      payload: data,
    });
  } catch (error) {
    console.error("getAllFirmWare", error);
  }
}

export async function getAllBatteryTemperatureCountApi(
  params: IGetAllBatteryTemperatureCount
) {
  const tokenRes = await getToken();
  const res = await axios.get(
    `${process.env.REACT_APP_WEBAPPAPI}/dashBoardV2/batteryTempCount?orgId=${params.payload.orgId}&customerId=${sessionStorage.getItem("selectedFilterCustomerId")}&groupId=${sessionStorage.getItem("groupDetails")}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: tokenRes.token!,
      },
    }
  );

  return res;
}

export function* getAllLiveSpeedBandCount(
  params: IGetAllLiveSpeedBandCountData
) {
  try {
    let { data } = yield call(getAllLiveSpeedBandCountApi, params);
    yield put({
      type: "STORE_ALL_LIVE_SPEED_BAND_COUNT",
      payload: data,
    });
  } catch (error) {
    console.error("getAllFirmWare", error);
  }
}

export async function getAllLiveSpeedBandCountApi(
  params: IGetAllLiveSpeedBandCountData
) {
  const orgId = String(params.payload.orgId || "").trim();
  const customerId = String(sessionStorage.getItem("selectedFilterCustomerId") || "").trim();
  const flag = String(params.payload.flag || "").trim();
  const groupId = String(sessionStorage.getItem("groupDetails") || "").trim();

  const url = `${process.env.REACT_APP_WEBAPPAPI}/dashBoardV2/speedBandCount?orgId=${orgId}&customerId=${customerId}&flag=${flag}&groupId=${groupId}`;

  const tokenRes = await getToken();
  const res = await axios.get(url, {
    headers: {
      "Content-Type": "application/json",
      Authorization: tokenRes.token!,
    },
  });


  return res;
}

export function* getAllCardCount(params: IGetAllCardCountData) {
  try {
    let { data } = yield call(getAllCardCountDataApi, params);
    yield put({
      type: "STORE_ALL_CARD_COUNT",
      payload: data,
    });
  } catch (error) {
    console.error("getAllFirmWare", error);
  }
}

export async function getAllCardCountDataApi(params: IGetAllCardCountData) {
 
  const tokenRes = await getToken();
  const res = await axios.get(
    `${process.env.REACT_APP_WEBAPPAPI}/dashBoardV2/getCardCountData?orgId=${params.payload.orgId}&customerId=${sessionStorage.getItem("selectedFilterCustomerId")}&flag=${params.payload.flag}&groupId=${sessionStorage.getItem("groupDetails")}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: tokenRes.token!,
      },
    }
  );

  return res;
}

export function* getAllAlertCount(params: IGetAllAlertCountData) {
  try {
    let { data } = yield call(getAllAlertCountApi, params);
    yield put({
      type: "STORE_ALL_ALERT_COUNT",
      payload: data,
    });
  } catch (error) {
    console.error("getAllFirmWare", error);
  }
}

export async function getAllAlertCountApi(params: IGetAllAlertCountData) {

  const tokenRes = await getToken();
  const res = await axios.get(
    `${process.env.REACT_APP_WEBAPPAPI}/dashBoardV2/getAlertTypeCount?orgId=${params.payload.orgId}&customerId=${sessionStorage.getItem("selectedFilterCustomerId")}&groupId=${sessionStorage.getItem("groupDetails")}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: tokenRes.token!,
      },
    }
  );

  return res;
}

export function* getAllTripData(params: IGetAllTripData) {
  try {
    let { data } = yield call(getAllTripDataApi, params);
    yield put({
      type: "STORE_ALL_TRIP_DATA",
      payload: data,
    });
  } catch (error) {
    console.error("getAllFirmWare", error);
  }
}

export async function getAllTripDataApi(params: IGetAllTripData) {

  const tokenRes = await getToken();
  const res = await axios.get(
    `${process.env.REACT_APP_WEBAPPAPI}/dashBoardV2/getTripData?orgId=${params.payload.orgId}&customerId=${sessionStorage.getItem("selectedFilterCustomerId")}&groupId=${sessionStorage.getItem("groupDetails")}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: tokenRes.token!,
      },
    }
  );

  return res;
}

export function* getAllVehicleData(params: IGetAllVehicleData) {
  try {
    let { data } = yield call(getAllVehicleDataApi, params);
    yield put({
      type: "STORE_ALL_VEHICLE_DATA",
      payload: data,
    });
  } catch (error) {
    console.error("getAllFirmWare", error);
  }
}

export async function getAllVehicleDataApi(params: IGetAllVehicleData) {

  const tokenRes = await getToken();
  const res = await axios.get(
    `${process.env.REACT_APP_WEBAPPAPI}/dashBoardV2/vehicleConsumingPower?orgId=${params.payload.orgId}&customerId=${sessionStorage.getItem("selectedFilterCustomerId")}&groupId=${sessionStorage.getItem("groupDetails")}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: tokenRes.token!,
      },
    }
  );

  return res;
}

export function* getAllFleetUptimeData(params: IGetAllFleetUptimeData) {
  try {
    let { data } = yield call(getAllFleetUptimeDataApi, params);
    yield put({
      type: "STORE_ALL_FLEET_UPTIME_DATA",
      payload: data,
    });
  } catch (error) {
    console.error("getAllFirmWare", error);
  }
}

export async function getAllFleetUptimeDataApi(params: IGetAllFleetUptimeData) {

  const tokenRes = await getToken();
  const res = await axios.get(
    `${process.env.REACT_APP_WEBAPPAPI}/dashBoardV2/fleetUptimeDataCount?orgId=${params.payload.orgId}&customerId=${sessionStorage.getItem("selectedFilterCustomerId")}&groupId=${sessionStorage.getItem("groupDetails")}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: tokenRes.token!,
      },
    }
  );

  return res;
}

export function* getAllVehicleRunningData(params: IGetAllVehicleRunningData) {
  try {
    let { data } = yield call(getAllVehicleRunningDataApi, params);
    yield put({
      type: "STORE_ALL_VEHICLE_RUNNING_DATA",
      payload: data,
    });
  } catch (error) {
    console.error("getAllFirmWare", error);
  }
}

export async function getAllVehicleRunningDataApi(
  params: IGetAllVehicleRunningData
) {

  const tokenRes = await getToken();

  const OEMURL = `${process.env.REACT_APP_WEBAPPAPI}/dashBoardV2/vehicleRunningDataCount?orgId=${params.payload.orgId}&customerId=${sessionStorage.getItem("selectedFilterCustomerId")}&groupId=${sessionStorage.getItem("groupDetails")}`;
  const OPURL = `${process.env.REACT_APP_WEBAPPAPI}/dashBoardV2/getDeviceSoldAndServiceCount?orgId=${params.payload.orgId}&customerId=${sessionStorage.getItem("selectedFilterCustomerId")}&groupId=${sessionStorage.getItem("groupDetails")}`;

  // ✅ explicit check
  const url = params.payload.flag === "oem" ? OEMURL : OPURL;

  const res = await axios.get(url, {
    headers: {
      "Content-Type": "application/json",
      Authorization: tokenRes.token!,
    },
  });

  return res;
}

export function* getAllSubscriptionCountData(params: IGetAllSubscriptionData) {

  try {
    let { data } = yield call(getAllSubscriptionCountDataApi, params)
    yield put({
      type: "STORE_ALL_SUBSCRIPTION_DATA", payload: data

    })
  } catch (error) {
    console.error("getAllFirmWare", error);

  }
}
export async function getAllSubscriptionCountDataApi(params: IGetAllSubscriptionData) {


  const tokenRes = await getToken();

  const res = await axios.get(
    process.env.REACT_APP_WEBAPPAPI + "/dashBoardV2/getDeviceSubscriptionCount",

    {
      params: {
        orgId: params.payload.orgId,
        //customerId: params.payload.customerId,
        customerId: sessionStorage.getItem("selectedFilterCustomerId"),
        groupId: sessionStorage.getItem("groupDetails"),
        //filterCustomerId:sessionStorage.getItem("selectedFilterCustomerId")
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: tokenRes.token!,
      },
    }
  );

  return res.data;
}
export function* getAllVehicleGrpahDetailsData(params: IGetAllVehicleGraphDetailsData) {

  try {
    let { data } = yield call(getAllVehicleGrpahDetailsApi, params)
    yield put({
      type: "STORE_VEHICLE_GRAPH_DETAILS", payload: data

    })
  } catch (error) {
    console.error("getAllFirmWare", error);

  }
}
export async function getAllVehicleGrpahDetailsApi(params: IGetAllVehicleGraphDetailsData) {
 

  const tokenRes = await getToken();

  const res = await axios.get(
    process.env.REACT_APP_WEBAPPAPI + "/dashBoardV2/getVehiclesServiceSoldData",
    {
      params: {
        orgId: params.payload.orgId,
        customerId: sessionStorage.getItem("selectedFilterCustomerId"),
        flag: params.payload.flag,
        page: 1,
        size: 100,
        groupId: sessionStorage.getItem("groupDetails"),
        //filterCustomerId:sessionStorage.getItem("selectedFilterCustomerId")
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: tokenRes.token!,
      },
    }
  );

  return res.data;
}
